import { connect } from "react-redux";
import { Divider } from "antd";
import { withRouter } from "react-router";
import React from "react";

import { ArrayUtil, DateUtil, RouteUtil } from "../../../util";
import ComparePanel, { TargetValueType } from "../CompareValuePanel";
import EmployeesUtil from "../../../util/employees";
import EmployeeTable from "../../../components/table/EmployeeTable";
import I18n from "../../../i18n";
import Layout from "../../../components/layout/Layout";
import PeopleOverviewComp from "../../../components/report/people_overview/PeopleOverviewComp";
import ReportAction from "../../../actions/ReportAction";
import UsageOverview from "../../../components/report/stress/StressUsageOverview";
import ROUTE from "../../../constants/route";
import UpgradePlanWarning from "../../UpgradePlanWarning";

const { fetchPeopleOverview } = ReportAction;

class PeopleOverview extends React.Component {
    comparePanel = null;
    dateRanges = {
    	[TargetValueType.Primary]: [],
    	[TargetValueType.Secondary]: []
    }
    constructor(props) {
    	super(props);
    	this.dateRanges = {
    		[TargetValueType.Primary]: DateUtil.getAllTimeDateRange(),
    		[TargetValueType.Secondary]: []
    	};
    	this.state = {
    		primaryData: null,
    		secondaryData: null
    	};
    }
    componentDidMount() {
    	const defaultDate = DateUtil.getAllTimeDateRange();
    	fetchPeopleOverview({
    		start: defaultDate[0].format("X"),
    		end: defaultDate[1].format("X")
    	}).then(res => {
    		this.setState({ primaryData: res || null });
    	});
    }
    onPrimaryDateChanged = (date) => {
    	if (date.length > 0) {
    		fetchPeopleOverview({
    			start: date[0].format("X"),
    			end: date[1].format("X")
    		}).then(res => this.setState({ primaryData: res || null }));
    	} else {
    		fetchPeopleOverview().then(res => {
    			this.setState({ primaryData: res || null });
    		});
    	}
    	this.dateRanges[TargetValueType.Primary] = date;
    	this.forceUpdate();
    }
    onSecondaryDateChanged = (date) => {
    	this.dateRanges[TargetValueType.Secondary] = date;
    	if (date.length > 0) {
    		fetchPeopleOverview({
    			start: date[0].format("X"),
    			end: date[1].format("X")
    		}).then(res => this.setState({ secondaryData: res || null }));
    	} else {
    		fetchPeopleOverview().then(res => {
    			this.setState({ secondaryData: res || null });
    		});
    	}
    	this.comparePanel.setShowCompare(ArrayUtil.isAliveArray(date));
    	this.forceUpdate();
    }
    render() {
    	const { primaryData, secondaryData } = this.state;
    	const showCompare = ArrayUtil.isAliveArray(this.dateRanges[TargetValueType.Secondary]);
    	const { category_title, choice, organizationLoading, history } = this.props;
    	const canEnterThisRoute= RouteUtil.CheckRoutePermission(true);
    	return (
    		<Layout>
    		<div style={{ marginTop: 10 }} />
    		{ canEnterThisRoute ?
    			(<React.Fragment>
    				<ComparePanel
    					setRef={(ref) => { this.comparePanel = ref; }}
    					header={I18n.t("people")}
    					subHeader={I18n.t("people_overview")}
    					showSecondaryDatePicker
    					primaryDate={this.dateRanges[TargetValueType.Primary]}
    					secondaryDate={this.dateRanges[TargetValueType.Secondary]}
    					onPrimaryDateChanged={this.onPrimaryDateChanged}
    					onSecondaryDateChanged={this.onSecondaryDateChanged}
    					primaryComponent={
    						<PeopleOverviewComp
    							data={primaryData}
    							isVertical={showCompare}
    							id="primary" />} 
    					secondaryComponent={
    						<PeopleOverviewComp
    							data={secondaryData}
    							isVertical={showCompare}
    							id="secondary" />} 
    				>
    				</ComparePanel>
    				<Divider />
    				<EmployeeTable
    					ref='employee_table'
    					sortPin={true}
    					disableSearchEmail={true}
    					onRowClick={(record) => { history.push(`/${ROUTE.INDIVIDUAL_USER}/${record.id}`); }}
    					choice={choice}
    					category_title={category_title}
    					loading={organizationLoading}
    					columns={EmployeesUtil.buildColumnsOverviewEmployees({ category_title })}
    				/>
    			</React.Fragment>)
    			: <UpgradePlanWarning/>
    		}
    	</Layout>);
    }
};
const mapStateToProps = state => ({
	organizationLoading: state.organization.loading,
	category_title: {
		category1_title: state.organization.organization.category1_title,
		category2_title: state.organization.organization.category2_title,
		category3_title: state.organization.organization.category3_title,
		category4_title: state.organization.organization.category4_title
	},
	choice: {
		choice1: state.organization.organization.choice1,
		choice2: state.organization.organization.choice2,
		choice3: state.organization.organization.choice3,
		choice4: state.organization.organization.choice4,
	}
});

export default connect(mapStateToProps)(withRouter(PeopleOverview));



// WEBPACK FOOTER //
// ./src/containers/ReportPanels/People/PeopleOverview.js